import React from 'react';
import GO from 'utils/GO';
import cookie from 'react-cookies';

export default props => {
	return (
		<>
			<>{GO('AA', 'AA', [<></>, <></>])}</>
		</>
	);
};
